<template>
  <div :class="classesRoot">
    <span :class="$style.text">
      {{ from }}
    </span>

    <UiIcon
      v-if="isIcon"
      :class="$style.icon"
      :color-inheritance="true"
      :name="iconName"
    />

    <IconValueStar
      v-if="isRating"
      :class="$style.iconRating"
      :value="qualityRating.rating"
    />
  </div>
</template>

<script>
  import { ICON_THEMES, ICONS_MAP } from '@/constants/calendar';
  import UiIcon from '@/components/UiIcon';
  import IconValueStar from '@/components/IconValueStar';

  export default {
    name: 'DayButtonContent',
    components: {
      UiIcon,
      IconValueStar,
    },
    props: {
      from: {
        type: String,
        default: null,
      },
      to: {
        type: String,
        default: null,
      },
      theme: {
        type: String,
        default: null,
      },
      qualityRating: {
        type: Object,
        default: null,
      },
    },
    computed: {
      iconName() {
        return ICONS_MAP[this.theme];
      },
      isIcon() {
        return this.theme !== ICON_THEMES.RATING && this.iconName;
      },
      isRating() {
        return this.qualityRating && this.theme === ICON_THEMES.RATING;
      },
      classesRoot() {
        const { theme, $style } = this;
        return {
          [$style.root]: true,
          [$style.hasIcon]: this.isIcon || this.isRating,
          [$style[`theme_${theme}`]]: theme,
        };
      },
    },
  };
</script>

<style lang="scss" module>
  $color: #000000;
  .root {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    //justify-content: space-between;
    //width: 100%;
  }

  .text {
    font-size: 17px;
    line-height: 20.4px;

    color: rgba(51, 51, 51, 1);
    font-weight: 400;
    font-variant-numeric: lining-nums tabular-nums;
    font-family: $fontFamilyInter;
    .hasIcon & {
      margin-right: 5px;
    }

    .theme_lunch & {
      color: $color;
    }

    .theme_meeting & {
      color: $color;
    }

    .theme_holiday & {
      color: $color;
    }

    .theme_exam & {
      color: $color;
    }

    .theme_sick-leave & {
      color: $color;
    }

    .theme_other & {
      color: $color;
    }

    .theme_innerexam & {
      color: $color;
    }

    .theme_theory & {
      color: $color;
    }

    .theme_planmeeting & {
      color: $color;
    }

  }

  .icon {
    position: absolute;
    right: -30px;

    .theme_money &,
    .theme_receipt &,
    .theme_lunch &,
    .theme_meeting &,
    .theme_holiday &,
    .theme_exam &,
    .theme_sick-leave &,
    .theme_innerexam &,
    .theme_theory &,
    .theme_planmeeting &,
    .theme_other & {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 4px;
      font-size: 14px;
      color: $colorWhite;
      box-sizing: border-box;
    }

    .theme_receipt & {
      color: $color;
      font-size: 15px;
    }
    .theme_money & {
      color: $color;
      font-size: 15px;
    }
    .theme_lunch & {
      color: $color;
      font-size: 15px;
    }

    .theme_theory & {
      color: $color;
      font-size: 14px;
    }

    .theme_planmeeting & {
      color: $color;
      font-size: 14px;
    }

    .theme_innerexam & {
      color: $color;
      font-size: 14px;
    }

    .theme_meeting & {
     color: $color;
    }

    .theme_holiday & {
      color: $color;
      font-size: 14px;
    }

    .theme_exam & {
      color: $color;
    }

    .theme_sick-leave & {
      color: $color;

      font-size: 14px;
    }

    .theme_other & {
      color: $color;
      font-size: 14px;
    }
  }

  .iconRating {
    margin-top: -4px;
    margin-right: -4px;
    margin-bottom: -4px;
  }
</style>
